const CONFIG = {
  GOOGLE_MAP_KEY: 'AIzaSyDuLSqLfqFwo2Y5ULRxBIgKSGjJDebHUKc',
  API_ROOT: 'http://example.com/'
}

export default CONFIG


// WEBPACK FOOTER //
// ./src/config/default.js